module.exports = __webpack_public_path__ + "img/margaret_squarepants.0107d065.jpg";